import React from "react";
import { AuthRecurringCancellationReview } from "../review/auth-recurring-cancellation-review.component";
import { callAuthCancelRecurring } from "../../../actions/authPayment.actions";
import getPaymentDay from "../misc/get-payment-day";
import { connect } from "react-redux";
import { usd } from "../../../utils/utils";
import moment from "moment";
import { AuthRecurringCancellationSummary } from "../summary/auth-recurring-cancellation-summary.component";

const RecurringCancellationFlowComponent = (props) => {
  const paymentResponse = props.authPayment.paymentResponse;
  const recurringPayment = props.selectedLoan.RecurringPayment;
  const { setProcessStep, processStep, selectedLoan, backToLoans } = props;

  const nextScheduled = moment(recurringPayment.NextScheduledDtTm).format("MM/DD/YYYY");
  const paymentDayToUse =
    recurringPayment.RecurringPaymentFrequency === "Monthly"
      ? moment.localeData().ordinal(recurringPayment.SelectedDay)
      : getPaymentDay(recurringPayment.RecurringPaymentFrequency, nextScheduled).replace(
          "Every other ",
          ""
        );

  switch (processStep) {
    case 1:
      return (
        <AuthRecurringCancellationReview
          openEndPaymentType={recurringPayment.OpenEndedPaymentType}
          firstPaymentDate={moment(recurringPayment.SelectedDate).format("MM/DD/YYYY")}
          paymentDay={paymentDayToUse}
          paymentFrequency={recurringPayment.RecurringPaymentFrequency}
          paymentAccount={recurringPayment.AccountLastFour}
          paymentAmount={usd.format(recurringPayment.Amount)}
          paymentResponse={paymentResponse}
          callAuthCancelRecurring={props.callAuthCancelRecurring}
          setProcessStep={setProcessStep}
          selectedLoan={selectedLoan}
          backToLoans={backToLoans}
          isInternalTransfer={props.paymentInfo.method === "LakeTrustAccount"}
        />
      );
    case 2:
      return (
        <AuthRecurringCancellationSummary
          authPayment={props.authPayment}
          paymentResponse={paymentResponse}
          selectedLoan={selectedLoan}
          backToLoans={backToLoans}
        />
      );
    case 3:
      return <div>Step 3</div>;
    case 4:
      return <div>Step 4</div>;
    default:
      return <div>Something has gone wrong.</div>;
  }
};

const mapDispatchToProps = {
  callAuthCancelRecurring,
};

const RecurringCancellationFlow = connect(
  null,
  mapDispatchToProps
)(RecurringCancellationFlowComponent);

export default RecurringCancellationFlow;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/flow-components/recurring-cancellation-flow.component.js